import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import config from '@@config';
import { textSearchParams } from '@@containers/Search/unitySearchParams';
import { requireRoles } from '@@router/guards';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { categoryListQuery } from './-components/categoryListQuery';
import { Layout } from './-components/Layout';

const requireCategoryRoles = requireRoles(config.navigation.categories.authorize);

export const Route = createFileRoute('/_authenticated/categories')({
    validateSearch: textSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => textSearchParams.parse(search),
    beforeLoad: ({ search }) => {
        requireCategoryRoles();

        const contentLocale = getContentLocale();

        // Built on every load, so the options follow the content language as well as the search
        return {
            allCategoriesQuery: categoryListQuery({ q: search.q }, contentLocale),
            activeCategoriesQuery: categoryListQuery({ q: search.q, active: true }, contentLocale),
            desknetCategoriesQuery: categoryListQuery(
                { q: search.q, syncedWithDesknet: true },
                contentLocale,
            ),
        };
    },
    loader: ({ context }) => {
        // Every tab's query runs, for their counts
        context.queryClient.query(context.allCategoriesQuery).catch(doNothing());
        context.queryClient.query(context.activeCategoriesQuery).catch(doNothing());
        context.queryClient.query(context.desknetCategoriesQuery).catch(doNothing());
    },
    component: Layout,
});
